import { useParams } from "react-router";
import {
  ReducedCustomerQuery,
  gqlReducedCustomer,
  CustomerRemoveAddressMutation,
  gqlCustomerRemoveAddress,
} from "../generated/graphql";
import { useGraphqlQuery, useGraphqlMutation } from "./graphql";
import { useCallback } from "react";

export function useGetReducedCustomer() {
  const { companySlug } = useParams<{ companySlug: string }>();
  const { requestState, refetch } = useGraphqlQuery<ReducedCustomerQuery>(
    gqlReducedCustomer,
    {
      variables: { slug: companySlug },
    }
  );
  return { requestState, refetch };
}

export function useCustomerRemoveAddress(): (id: string) => Promise<boolean> {
  const { companySlug } = useParams<{ companySlug: string }>();
  const mutation = useGraphqlMutation<CustomerRemoveAddressMutation>(
    gqlCustomerRemoveAddress
  );
  return useCallback(
    async (id: string) => {
      const res = await mutation({
        variables: {
          slug: companySlug,
          id,
        },
      });
      if (!res) {
        throw new Error();
      }
      return res.CustomerRemoveAddress;
    },
    [companySlug, mutation]
  );
}
